module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "size": "mini"
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "名称"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "关键字"
    },
    model: {
      value: (_vm.filters.keyword),
      callback: function($$v) {
        _vm.$set(_vm.filters, "keyword", $$v)
      },
      expression: "filters.keyword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('my-button', {
    attrs: {
      "QueryButtonShow": "",
      "AddButtonShow": ""
    },
    on: {
      "select-type": _vm.clickBtn
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.deviceTypes,
      "highlight-current-row": "",
      "border": "",
      "height": _vm.formHeight,
      "size": "mini"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "sortable": "",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "keyword",
      "label": "关键字",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "factorNames",
      "label": "监测因子",
      "min-width": "250",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "moveFlag",
      "label": "是否移动噪声"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.moveFlag == 1) ? _c('span', [_vm._v("是")]) : _c('span', [_vm._v("否")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('table-update-button', {
          on: {
            "select-type": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "total": _vm.total,
      "page-sizes": [10, 20, 30, 40, 50],
      "current-page": _vm.page
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        _vm.page = $event
      },
      "update:current-page": function($event) {
        _vm.page = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.type,
      "visible": _vm.formVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "formDeviceType",
    attrs: {
      "model": _vm.formDeviceType,
      "label-width": "80px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formDeviceType.name),
      callback: function($$v) {
        _vm.$set(_vm.formDeviceType, "name", $$v)
      },
      expression: "formDeviceType.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "关键字",
      "prop": "keyword"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formDeviceType.keyword),
      callback: function($$v) {
        _vm.$set(_vm.formDeviceType, "keyword", $$v)
      },
      expression: "formDeviceType.keyword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "监测因子",
      "prop": "factorIds",
      "id": "facCheck"
    }
  }, [(_vm.type == "修改") ? _c('div', [_c('el-checkbox-group', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.formDeviceType.factorIds),
      callback: function($$v) {
        _vm.$set(_vm.formDeviceType, "factorIds", $$v)
      },
      expression: "formDeviceType.factorIds"
    }
  }, _vm._l((_vm.FactorList), function(fac) {
    return _c('el-checkbox', {
      key: fac.factorId,
      attrs: {
        "label": fac.factorId
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(fac.name))])
  }), 1)], 1) : _c('div', [_c('el-checkbox-group', {
    model: {
      value: (_vm.formDeviceType.factorIds),
      callback: function($$v) {
        _vm.$set(_vm.formDeviceType, "factorIds", $$v)
      },
      expression: "formDeviceType.factorIds"
    }
  }, _vm._l((_vm.FactorList), function(fac) {
    return _c('el-checkbox', {
      key: fac.factorId,
      attrs: {
        "label": fac.factorId
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(fac.name))])
  }), 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "移动噪声?"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": _vm.type == '修改' ? true : false
    },
    model: {
      value: (_vm.formDeviceType.moveFlag),
      callback: function($$v) {
        _vm.$set(_vm.formDeviceType, "moveFlag", $$v)
      },
      expression: "formDeviceType.moveFlag"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "描述"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formDeviceType.remark),
      callback: function($$v) {
        _vm.$set(_vm.formDeviceType, "remark", $$v)
      },
      expression: "formDeviceType.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancleSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitData.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-52484ab8"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/device/DeviceType.vue
// module id = 1919
// module chunks = 1